<main id="essay-checker">
  <div class="container-fluid hero-bg">
    <app-header></app-header>

    <div class="container mt-5">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 col-12 mb-4">
          <h1 class="heading">Essay Checker</h1>
          <p class="description">
            Get GrammarIn’s essay checker for free. Paste text to check essays
            for unclear sentences, misspelled words and repetition issues like a
            PRO!
          </p>
        </div>
      </div>
    </div>

    <section class="mx-auto" style="max-width: 1320px; min-height: 530px;">
      <ng-template #landerContainer></ng-template>
    </section>
    <!-- <section class="container">
      <div class="editor-card">
        <p
          class="text-left success-msg"
          *ngIf="got_recpatcha"
          [ngStyle]="{
            color: color,
            'background-color': '#f8d7da',
            padding: '2px'
          }"
        >
          <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
          {{ recaptcha_message }}
        </p>

        <div class="row-1">
          <div class="icon-bar">
            <div
              style="cursor: pointer"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div style="cursor: pointer" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div style="cursor: pointer" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>

          <div class="flex-1">
            <div style="position: relative">
              <quill-editor
                id="editor"
                [(ngModel)]="homeText"
                [modules]="editorModules"
                [theme]="'snow'"
                (onEditorCreated)="onEditorCreated($event)"
                class="typing-editor px-3"
                id="editor"
                #editor
                style="overflow-y: auto; overflow-x: hidden"
                (click)="onclickeditor($event)"
                [(ngModel)]="text"
                (onEditorCreated)="onHandleFormatting($event)"
                (onContentChanged)="count_Words_Character2()"
                placeholder=""
              >
              </quill-editor>

              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
              <div class="progress-loader-div">
                <div class="progress-loader" *ngIf="loaderAlert"></div>
              </div>
              <div class="bottom-icon">
                <div class="word-char">
                  <span class="wordCount">
                    Words: {{ char_count === 0 ? 0 : word_count }}
                  </span>
                  <span class="wordCount"
                    >Total Characters: {{ char_count }}</span
                  >
                </div>

                <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                  <div class="captcha-modal">
                    <div
                      id="recaptcha-container"
                      class="recaptcha-container"
                      data-size="compact"
                      data-theme="light"
                    ></div>
                  </div>
                </div>

                <div class="">
                  <button
                    class="btn-essay-check buton"
                    (click)="handleButtonClick()"
                  >
                 
                    Check Essay
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>

  <section class="container margin-top-bottom">
    <div class="row-5">
      <div class="">
        <h2 class="headings sm-screen">Introduction to Essay Checker</h2>
        <p class="paragraph sm-screen">
          The essay checker is a powerful tool designed to assist writers in
          improving the quality and clarity of their essays. It enables students
          and professionals to enhance their essay writing with real-time
          suggestions and corrections for grammar, spelling, and punctuation,
          helping them create polished, impactful, and professional essays.
          Users can simply paste their essays into our free essay checker and it
          will quickly scan the text for issues. It offers suggestions for
          improvement, like rephrasing sentences or replacing vague language
          with precise and impactful terms.
        </p>
      </div>
      <div class="essay-checker">
        <img
          src="/assets/images/essay-checker/easy.webp"
          style="max-width: 100%"
          srcset="
            /assets/images/essay-checker/768.webp        768w,
            /assets/images/essay-checker/480-screen.webp 480w,
            /assets/images/essay-checker/320-screen.webp 320w
          "
          class="img-proofread"
          sizes="
                (max-width: 425px) 320px,
                (min-width: 425px) and (max-width: 550px) 480px,
                (min-width: 550px) and (max-width: 2560px) 768px,
                1080px"
          alt="essay-checker"
          width="528"
          height="470"
        />
      </div>
    </div>
  </section>

  <div class="container mt-5">
    <app-premium />
  </div>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-8 col-md-9 mb-4">
        <h2 class="headings">How to Use Essay Checker</h2>
        <p class="paragraph">
          Using the
          <a href="https://www.grammarin.com/essay-checker"> essay checker</a>
          is simple and hassle-free. No complicated settings or lengthy
          installation is needed, just follow this step-by-step guide:
        </p>
      </div>
    </div>

    <div class="row-2">
      <div *ngFor="let step of Tools">
        <div class="card">
          <span class="pbg"><app-icons-free-tools [name]="step.icon" /></span>
          <span>{{ step.description }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="mar80">
    <div class="container-fluid workingD">
      <div class="row">
        <div class="col-lg-6">
          <div class="workingDContainer">
            <h2 class="title tcS pr">
              How Does GrammarIn’s Essay Corrector Work
            </h2>
            <p class="description-new tcS">
              The essay corrector by GrammarIn is an advanced tool that utilizes
              artificial intelligence algorithms. These latest AI technologies
              are programmed to analyze text and identify potential errors
              within a text. Its extensive database of grammar rules and
              <a
                href="https://www.grammarin.com/handbook/style"
                class="text-white a-white"
              >
                style guidelines</a
              >
              enables it to provide accurate and helpful feedback.
              <br />
              <br />

              When you enter an essay, the free essay corrector instantly scans
              it for errors, highlighting every mistake. Its detailed
              explanations on each suggestion help you understand grammar
              concepts and make confident corrections.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="imgDiv">
            <img
              src="../../assets/images/essay-checker/essay screen.png"
              alt="editor"
              class="image"
              height="395px"
              width="704px"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    class="container margin-top-bottom text-center justify-content-center"
  >
    <div class="row-3">
      <div *ngFor="let card of cards3">
        <div class="card-3">
          <app-icons-free-tools [name]="card.icon" />
          <h3 class="card-3-heading pt-2">{{ card.heading }}</h3>
          <span class="card-3-span">{{ card.description }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <h2 class="headings col-lg-9 col-md-9">
        Boost Your Grades: Essay Checker Free for Students
      </h2>

      <p class="description col-lg-10 col-12">
        The essay grade checker understands the importance of academic success
        and offers its services to the students for free. This valuable resource
        can help <strong>students improve their writing skills</strong>. It also
        increases their confidence to achieve higher grades. Students can ensure
        that their essays are well-written, error-free, and effectively convey
        their ideas by using our college essay checker.
      </p>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-12 mb-4">
        <h2 class="headings">Types of Mistakes Our Essay Corrector Correct</h2>
        <p class="paragraph">
          Our essay corrector is designed to identify and correct a wide range
          of <strong>common grammar mistakes </strong>. Essay is the foundation
          of effective academic writing, and even experienced students can make
          mistakes. Our essay corrector can help you identify and correct common
          grammar errors in seconds.
        </p>
      </div>
    </div>
    <div class="row-7">
      <div *ngFor="let section of CG">
        <div class="card-1-1">
          <app-icons-free-tools [name]="section.icon" />
          <h3 class="card-1h2">{{ section.title }}</h3>
          <p class="description" [innerHTML]="section.description"></p>
        </div>
      </div>
    </div>
    <div class="row-8">
      <div *ngFor="let section of EDU">
        <div class="card-1-1">
          <app-icons-free-tools [name]="section.icon" />
          <h3 class="card-1h2">{{ section.title }}</h3>
          <p class="description" [innerHTML]="section.description"></p>
        </div>
      </div>
    </div>
  </section>

  <section
    class="container margin-top-bottom text-center justify-content-center"
  >
    <div class="sm-scrn">
      <div class="row-6 manual-area">
        <h2 class="headings pad-x">
          Ensure Clarity in Your Essay Writing with GrammarIn Free Essay Checker
        </h2>

        <p class="manual-description">
          A clear and concise essay is essential for academic success. Our essay
          checker can help students achieve clarity by identifying and
          suggesting improvements to intricate each sentence of their essay.
          Students can ensure that their essays are easy to understand and
          engaging to read by using our college essay checker. It is a valuable
          asset for anyone who wants to improve their writing skills and produce
          high-quality essays.
        </p>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row-10">
      <div class="row-9 w-100 base-p">
        <h2 class="headings sm-screen mt-3">
          Benefits of Students’ Favorite Essay Corrector
        </h2>
        <p class="description sm-screen">
          Students have the advantage to utilize the essay corrector for
          improving the overall essay effortlessly. Here is how they enhance
          essays.
        </p>
      </div>
      <div class="grid-container">
        <div
          *ngFor="let paper of writingStyler"
          class="easy-paper-item"
          [ngClass]="{
            essay: paper.title === 'Improve Grammar and Spelling',
            save: paper.title === 'Save Time',
            enhance: paper.title === 'Enhance Writing Style',
            Avoid: paper.title === 'Avoid Plagiarism',
            Support: paper.title === 'Support Academic Integrity'
          }"
        >
          <h3 class="easy-reader">{{ paper.title }}</h3>
          <p
            [innerHTML]="getSafeHtml(paper.description)"
            class="paper-reader"
          ></p>
        </div>
      </div>
    </div>
  </section>

  <section class="container-fluid blue-area margin-top-bottom py-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-8 col-12 mb-4">
          <h2 class="headings text-white">
            Types of Essays Students Can Check and Correct with GrammarIn Free
            Essay Checker
          </h2>
          <p class="description text-white">
            Students can review various essay types to correct mistakes and make
            their work stand out for better grades. Below are a few commonly
            used essay types that you can check with our essay corrector:
          </p>
        </div>
      </div>
      <div class="row-4">
        <div *ngFor="let card of TWCF" class="sm-screen">
          <span class="bgw"> <app-icons-free-tools [name]="card.icon" /></span>
          <h3 class="heading-TWCF">{{ card.heading }}</h3>
          <p
            [innerHTML]="getSafeHtml(card.description)"
            class="paper-reader"
          ></p>
        </div>
      </div>
    </div>
  </section>

  <section class="fqa margin-top-bottom">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-12 mb-md-4 mb-2">
          <h2 class="headings">Frequently Asked Questions</h2>
        </div>
      </div>

      <div class="v-pills-tab-list">
        <div class="" id="row_faqs">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="container container-grid"
              style="width: min(100% - 40px, 768px)"
            >
              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q1' }"
                (click)="toggleTab('q1')"
                id="v-pills-first-tab"
                aria-controls="q1"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q1'">
                    Is the Essay Checker Free to Use?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q1'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q1'"
                  />
                </div>

                <div
                  aria-labelledby="q1"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q1' }"
                  id="q1"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Yes! The online essay checker is completely free to use.
                    Users can directly access and use it without having to pay
                    for any subscription or membership.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q2' }"
                (click)="toggleTab('q2')"
                id="v-pills-2nd-tab"
                aria-controls="q2"
                aria-expanded="false"
              >
                <div class="d-flex nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q2'">
                    Can I Use the Essay Corrector for Academic Papers?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q2'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q2'"
                  />
                </div>

                <div
                  aria-labelledby="q2"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q2' }"
                  id="q2"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Absolutely! The essay corrector can be used for improving
                    academic papers. It is a powerful tool designed to help
                    students to ensure that their essays and papers are
                    error-free and well-written.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q3' }"
                (click)="toggleTab('q3')"
                id="v-pills-3rd-tab"
                aria-controls="q3"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q3'">
                    Is My Essay Safe When Using GrammarIn’s Essay Fixer?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q3'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q3'"
                  />
                </div>

                <div
                  aria-labelledby="q3"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q3' }"
                  id="q3"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    GrammarIn’s essay fixer does not compromise on the security
                    of the user’s content. It protects your privacy and ensures
                    that your data is kept confidential.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q4' }"
                (click)="toggleTab('q4')"
                id="v-pills-4th-tab"
                aria-controls="q4"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q4'"
                  >
                    Do I Correct My Essay Multiple Times?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q4'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q4'"
                  />
                </div>

                <div
                  aria-labelledby="q4"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q4' }"
                  id="q4"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Of course, you can correct your essays an unlimited number
                    of times without having any limitations.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q5' }"
                (click)="toggleTab('q5')"
                id="v-pills-5th-tab"
                aria-controls="q5"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q5'"
                  >
                    Does This Essay Corrector Catch All Grammar Mistakes?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q5'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q5'"
                  />
                </div>

                <div
                  aria-labelledby="q5"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q5' }"
                  id="q5"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    The free essay checker and corrector is trained on a vast
                    amount of data to learn <strong>grammar rules </strong>,
                    syntax, and specific terminologies for each subject. That is
                    why it has the ability to correct all the possible grammar
                    mistakes instantly.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q6' }"
                (click)="toggleTab('q6')"
                id="v-pills-6th-tab"
                aria-controls="q6"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q6'"
                  >
                    Is This Free Essay Checker Legal to Use?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q6'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q6'"
                  />
                </div>

                <div
                  aria-labelledby="q6"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q6' }"
                  id="q6"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Yes, our essay checker is legal as long as it does not
                    violate copyright or academic integrity policies.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q7' }"
                (click)="toggleTab('q7')"
                id="v-pills-7th-tab"
                aria-controls="q7"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q7'"
                  >
                    Can Non-Native English Speakers Use This Essay Fixer?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q7'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q7'"
                  />
                </div>

                <div
                  aria-labelledby="q7"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q7' }"
                  id="q7"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Yes, non-native English speakers can definitely use this
                    essay fixer. The tool is designed to help people from all
                    backgrounds improve their essay writing skills, regardless
                    of their native language.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q8' }"
                (click)="toggleTab('q8')"
                id="v-pills-8th-tab"
                aria-controls="q8"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q8'"
                  >
                    Does the Essay Corrector Free Work with Different Types of
                    Essays?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q8'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q8'"
                  />
                </div>

                <div
                  aria-labelledby="q8"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q8' }"
                  id="q8"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    The essay corrector works with different types of essays,
                    including narrative, descriptive, expository, and persuasive
                    essays.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-feedback></app-feedback>

<!-- scroll  -->
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<!-- error  -->
<div *ngIf="error" class="backdrop" id="error-22"></div>
<div *ngIf="error" class="content-div" id="error-22-cont">
  <div class="text-center" id="error-22-contInner">
    <img src="/assets/images/paraphrasing tool/alert.svg" alt="alert" />
    <div class="content-div-p">
      <p class="error mt-4" id="errorPT">
        {{ errorAlerts }}
      </p>
    </div>
    <button class="mt-5 butn-alert" (click)="closeErrorDiv()">Ok</button>
  </div>
</div>

<app-premium-modal-startup />

<app-footer></app-footer>
